import getMigrationMode from './getMigrationMode';
import getTxpEntitiesStateFromString from './getTxpEntitiesState';
import TxpStatus from '../../schema/TxpStatus';

/**
 * Parses txpStatus json string to obtain TxpStatus object
 */
export default function convertTxpStatusBlobToObject(txpStatusBlob: string): TxpStatus {
    if (txpStatusBlob) {
        let parsedBlob: any;
        try {
            parsedBlob = JSON.parse(txpStatusBlob);
        } catch (e) {
            parsedBlob = null;
        }
        if (parsedBlob) {
            return {
                state: getTxpEntitiesStateFromString(parsedBlob.State),
                utcTimestamp: parsedBlob.UtcTimestamp,
                processingErrors: parsedBlob.ProcessingErrors,
                isEmailDonationRequested: parsedBlob.IsEmailDonationRequested,
                migrationMode: getMigrationMode(parsedBlob.MigrationMode),
            };
        }
    }
    return null;
}
